<template>
  <v-container>
    <v-card>
      <v-data-table :headers="headers" :items="token" :custom-sort="sortByDate">
        <template v-slot:item.mobile="props">
          <v-icon>{{
            props.item.mobile ? 'phone_iphone' : 'desktop_mac'
          }}</v-icon>
        </template>

        <template v-slot:item.identifier="props">
          <v-edit-dialog
            :return-value.sync="props.item.identifier"
            large
            persistent
            @save="save(props.item)"
          >
            <div class="subheading">{{ props.item.identifier }}</div>

            <v-text-field
              slot="input"
              v-model="props.item.identifier"
              :rules="[max60chars]"
              label="Edit"
              single-line
              counter="60"
              autofocus
            ></v-text-field>
          </v-edit-dialog>
        </template>

        <template v-slot:item.created_at="props">
          {{ props.item.created_at | formatDate }}
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip v-if="item.id != localTokenID" bottom>
            <template v-slot:activator="{ on }">
              <v-icon @click="deleteItem(item)" v-on="on">delete</v-icon>
            </template>
            <span>Delete</span>
          </v-tooltip>

          <v-tooltip v-else bottom>
            <template v-slot:activator="{ on }">
              <v-icon color="primary" v-on="on">my_location</v-icon>
            </template>
            <span>This Device</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import AccountService from '@/services/account.service'

export default {
  props: {
    token: Array
  },
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: '',
          value: 'mobile',
          sortable: false
        },
        {
          text: 'Identifier',
          value: 'identifier',
          sortable: false
        },
        { text: 'Created At', value: 'created_at' },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      max60chars: v => v.length <= 60 || 'Input too long!'
    }
  },
  computed: {
    localTokenID() {
      return this.$store.getters.localTokenID
    }
  },
  methods: {
    sortByDate(items, idx, desc) {
      return items.sort((a, b) => {
        const dateA = new Date(a.created_at)
        const dateB = new Date(b.created_at)
        return desc ? dateA - dateB : dateB - dateA
      })
    },
    async save(token) {
      try {
        await AccountService.updateToken({
          id: token.id,
          identifier: token.identifier
        })
        this.$emit('update-token', token)
      } catch (error) {
        console.log('failed to update token', error)
      }
    },

    async deleteItem(item) {
      if (
        await this.$root.$confirm('Delete', 'Are you sure?', {
          color: 'warning'
        })
      ) {
        try {
          const index = this.token.indexOf(item)
          await AccountService.deleteToken(this.token[index].id)
          this.$emit('delete-token', this.token[index].id)
        } catch (error) {
          console.log('failed to delete token', error)
        }
      }
    }
  }
}
</script>

<style></style>
